export enum Permission {
  ReportsReports = 'reports_retailer_reports.view',
  ReportsAnalytics = 'reports_analytics.legacy_permission',
  Tlogs = 'tlogs.legacy_warehouse_level_permission',
  AlcoholTlogs = 'alcohol_tlogs.legacy_warehouse_level_permission',
}
